import { useMutation, useQueryClient } from "@tanstack/react-query";
import staffApi from "../../api/staffApi";
type UpdateStaffPayload = {
    id: number;
    data: FormData
};

export const useUpdateStaff = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: UpdateStaffPayload) =>
            staffApi.updateProfileStaff(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["users"],
            });
        },
    });
};

